// Components
import StyledCard from '@/components/global-components/styled-card/StyledCard';
import InformationCard from '@/components/global-components/information-card/InformationCard';
import Button from '@/components/global-components/Button';
import ButtonWithDropDown from '@/components/global-components/ButtomDropdown';

// Node Modules
import { nanoid } from 'nanoid';
import React, { useState } from 'react';

// Themes
import theme from '@/themes/index';

const Program = ({
  content,
  isDesktop,
  flexDirection = {},
  alternatePosition = false,
  infoContainerStyle = {},
  showTitle,
}) => {
  const {
    cardContent,
  } = content;


  const programUrls = {
    'Onsite': 'https://www.studyspanishcostarica.com/login.aspx',
    'Online': 'https://www.studyspanishcostarica.com/campusvirtual/login.aspx',
  };
  

  const testIfValidURL = str => {
    const pattern = new RegExp('^https?:\\/\\/' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    
    if (!pattern.test(str)) {
      return `https://${str}`;
    }
    return str;
  };

  const programLink = content.node.enrollLink?.url ? testIfValidURL(content.node.enrollLink?.url) : programUrls[content.node.programType];

  const getStyleCardContent = () => {
    return (
      <>
        <InformationCard content={{
          'cardContent': {
            Typename: 'Styled_card_content',
            'title': content.node.title,
            'description': content.node.description,
          },
          'title': content.node.title,
        }} showTitle={showTitle} />
        <div className='buttons-container'>
          <Button
            className={'ghost'}
            key={nanoid()}
            text={'Contact Us'}
            href={'/contact'}
            target={'_blank'}
            styles={{
              width: isDesktop ? 'fit-content' : '100%',
              padding: '0 1rem',
            }}></Button>
          {content.node.variants[0] && !content.node.variants[0].variantId ? (
            <Button
              className={'primary'}
              key={nanoid()}
              text={'Book Now'}
              href={programLink}
              target={'_blank'}
              styles={{
                width: isDesktop ? 'fit-content' : '100%',
                padding: '0 1rem',
              }}></Button>
          ) : ''}
          {content.node.variants[0] && content.node.variants[0].variantId ? (
            <ButtonWithDropDown
              elements={getVariantData()}
              label={'Book now'} />
          ) : ''}
        </div>
        <style jsx>{`
          div.buttons-container {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 1rem;
            align-items: center;
          }

          @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
            div.buttons-container {
              flex-direction: row;
              gap: 2rem;
              justify-content: center;
            }
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.buttons-container {
              justify-content: left;
            }
          }
        `}</style>
      </>
    );
  };

  function getVariantData() {
    let elementsVar = []
    if (content.node.variants && content.node.variants.length > 0) {
      elementsVar = content.node.variants.map(el => {
        return {
          'text': el.variantName, 'subtext': el.smallDescription, 'url': el.variantLink?.url ? testIfValidURL(el.variantLink.url) : `${programUrls[content.node.programType]}/${el.variantId}`, 'target': '_blank',
        }
      })
    }

    return elementsVar;
  }


  return (
    <>
      <div className='program-container'>
        <StyledCard
          content={{
            'image': content.node.programImage,
          }}
          imageStyles={{
            maxWidth: isDesktop ? '28.75rem' : '100%',
            maxHeight: isDesktop ? '25rem' : '100%',
          }}
          containerStyle={alternatePosition ? flexDirection : {
            flexDirection: isDesktop ? 'row-reverse' : 'column-reverse',
          }}
          infoContainerStyle={alternatePosition ?
            infoContainerStyle
            : {
              paddingRight: '0',
              paddingLeft: '0.5rem',
              flexDirection: 'column',
            }}>
          {getStyleCardContent()}
        </StyledCard>
      </div>
      <style jsx>{`
          div.program-container {
            display: flex;
            flex-direction: column;
          }
        `}</style>
      <style global jsx>{`
          div.program-container .container .info-container .card-content h5,
          h6,
          ul {
            padding-bottom: 1rem;
            margin-block-start: 0;
            margin-block-end: 0;
            margin-inline-start: 0;
            margin-inline-end: 0;
          }

          div.program-container .container .info-container .card-content h5 {
            font-size: 1.5rem;
            line-height: 1.575rem;
          }

          div.program-container .container .info-container .card-content h6 {
            font-size: 1.25rem;
            line-height: 1.225rem;
          }

          div.program-container .container .info-container .card-content p {
            margin: 0;
            padding-bottom: 1.5rem;
            text-align: center;
          }

          div.program-container .container .info-container .card-content ul {
            padding-inline-start: 1rem;
            text-align: left;
            font-family: ${theme.fontFamilies.openSans};
            font-size: 1rem;
            line-height: 1.2255rem;
          }

          div.program-container
            .container
            .info-container
            .card-content
            ul
            li
            p {
            padding: 0;
          }

          @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
            div.program-container .container .info-container .card-content p {
              padding-bottom: 2rem;
              text-align: justify;
            }

            div.program-container .container .info-container .card-content h5 {
              font-size: 2rem;
              line-height: 3rem;
            }

            div.program-container .container .info-container .card-content h6 {
              font-size: 1.5rem;
              line-height: 2.25rem;
            }

        

            div.program-container .container .info-container .card-content ul {
            font-size: 1.25rem;
            line-height: 1.875rem;
          }
          }
        `}</style>
    </>
  );
};

export default Program;
